import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './App.jsx'
import { ArticlesIndex } from './pages/ArticlesIndex'
import { ArticlePage } from './pages/ArticlePage'

// Initialize Sentry as early as possible
Sentry.init({
  dsn: "https://344d8b1c44803149fcdb6674559eb1a8@o4509892851204096.ingest.us.sentry.io/4509892870209536",
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/articles" element={<ArticlesIndex />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
